import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './index.css'; // Estilos globais

import { ThemeProvider } from './context/ThemeContext'; // Exemplo de provider de tema
import { ErrorBoundary } from './components/ErrorBoundary';




const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ErrorBoundary>
      <ThemeProvider>
        <Router>
          <App />
        </Router>
      </ThemeProvider>
    </ErrorBoundary>

);
